export const REDUCER_PROJECT = 'projects';
export const PROJECTS_API = 'projectsApi';
export const ACTION_RESET_FILTERS = 'resetFilters';
export const ACTION_SET_FILTERS = 'setFilters';
export const ACTION_SET_SEARCH = 'setSearch';
